import type { taskEither } from "fp-ts";

import type { Common, Create, Delete, GetMany } from "./ios";

import type { AuthenticationError, NotFoundError, UnexpectedError } from "~/shared/error";

abstract class Provider {
  abstract create(
    params: Create.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError, Common.OutSchema>;
  abstract delete(
    params: Delete.In,
  ): taskEither.TaskEither<UnexpectedError | AuthenticationError | NotFoundError, void>;
  abstract getMany(): taskEither.TaskEither<UnexpectedError | AuthenticationError, GetMany.Out>;
}

export { Provider };
